import { all, call, put } from "redux-saga/effects";
import { deleteAccountFinaliseEnd } from "../actions/deleteaccountactions";
import { reportError, reportSuccess } from "../actions/erroractions";
import { moveToLoginPage } from "../actions/routeactions";
import { deleteAccountFinaliseAPI } from "../api/DeleteAccountFinaliseCall";

export function* deleteAccountFinaliseSaga(action) {
  try {
    const result = yield call(deleteAccountFinaliseAPI, action);

    if (result.ok) {
      yield all([
        put(moveToLoginPage()),
        put(reportSuccess("Account deleted")),
        put(deleteAccountFinaliseEnd())
      ]);
    } else {
      yield all([
        put(reportError(result.message)),
        put(deleteAccountFinaliseEnd()),
      ]);
    }
  } catch (e) {
    yield all([
      put(reportError("Unable to reach server")),
      put(deleteAccountFinaliseEnd()),
    ]);
  }
}
